import { ErrorMessage } from "@hookform/error-message";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import "react-medium-image-zoom/dist/styles.css";
import { NumericFormat } from "react-number-format";
import { useHistory, useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { InputGroup, InputGroupAddon } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../components/Component";
import { useUser } from "../../context/user";
import { GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { BILL_STATUS, getDefaultPnBill, randomString, TRUCK_TYPE } from "../../utils/Utils";

const BILL_STATUS_OPTIONS = Object.keys(BILL_STATUS).map((c) => ({
  label: BILL_STATUS[c],
  value: c,
}));

const MyBillForRentalContractDetail = () => {
  const {
    state: { user },
  } = useUser();
  const history = useHistory();
  const { search } = useLocation();
  const duplicateId = new URLSearchParams(search).get("duplicateId");
  const params = useParams();
  const id = duplicateId || params.id;
  const randomId = () => {
    const id = `PN-${moment().format("YYYYMMDD")}-${randomString(10)}`;
    return id
  }

  const methodForm = useForm({
    defaultValues: {
      ...getDefaultPnBill(),
      driverId: user.id,
      id: randomId(),
    },
    shouldFocusError: true,

  });
  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
    watch,
  } = methodForm;

  const driveRentalContractId = watch("driveRentalContractId");
  const truckId = watch("truckId");
  const subDriverId = watch("subDriverId");

  const [loading, setLoading] = useState(false);

  const [smOption, setSmOption] = useState(false);
  const [driverOptions, setDriverOptions] = useState([]);
  const [truckOptions, setTruckOptions] = useState([]);
  const [ingredientOptions, setIngredientOptions] = useState([]);
  const [driveRentalContractOptions, setDriveRentalContractOptions] = useState([]);



  useEffect(() => {

    GET("/user/list-drivers", {}, true).then((resp) => {
      const { data } = resp;
      if (data) {
        setDriverOptions(
          data.map((c) => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        );
      }
    });

    GET("/drive-rental-contract", {
      status: 'INIT'
    }, true).then((resp) => {
      const { data: { rows } } = resp;
      if (rows) {
        setDriveRentalContractOptions((oldOptions) => {
          const newOptions = [...oldOptions];
          const oldOptionValues = oldOptions.map(c => c.value);
          rows.forEach((c) => {
            if (!oldOptionValues.includes(c.id)) {
              newOptions.push({
                label: `${c?.customer?.name} - HĐ số ${c.id} - Từ "${c?.info?.from}" đến "${c?.info?.to}"`,
                value: c.id,
                data: c,
              })
            }
          })

          return newOptions;
        });
      }
    });

    GET(`/ingredient`, {}, true)
      .then(({ data }) => {
        setIngredientOptions(data.rows.map(c => ({
          label: `${c.name}`,
          value: c.id,
          data: c
        })))
      })

    GET("truck", {
      type: TRUCK_TYPE.TRUCK
    }, true).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setTruckOptions(
          data.rows.map((c) => ({
            label: c.id,
            value: c.id,
            data: c,
          }))
        );
      }
    });

  }, []);

  useEffect(() => {
    if (id) {
      GET(`pn-bill-for-driver/${id}`, {}, true)
        .then((resp) => {
          const { data } = resp;
          data.createdAt = moment(data.createdAt).format("YYYY-MM-DD HH:mm");
          reset(data);
          const { driveRentalContract } = data
          if (driveRentalContract) {
            setDriveRentalContractOptions((oldOptions) => {
              const newOptions = [...oldOptions];
              const oldOptionValues = oldOptions.map(c => c.value);
              if (!oldOptionValues.includes(driveRentalContract.id)) {
                newOptions.push({
                  label: `${driveRentalContract?.customer?.name} - HĐ số ${driveRentalContract.id} - Từ "${driveRentalContract?.info?.from}" đến "${driveRentalContract?.info?.to}"`,
                  value: driveRentalContract.id,
                  data: driveRentalContract,
                })
              }
              return newOptions;
            });
          }
        })
        .catch((err) => {
          toast.error(err.response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
          history.goBack();
        })
    }
  }, [id]);

  const onHandleSubmit = () => {
    setLoading(true);
    const data = getValues();
    const {
      createdAt,

      ingredientId,
      truckId,
      finalMerchandiseWeight,

      driveRentalContractId,
      note,
      subDriverId,
    } = data

    const formData = {
      createdAt,

      ingredientId,
      truckId,
      finalMerchandiseWeight: finalMerchandiseWeight || 1,

      driveRentalContractId,
      note: note || null,

      subDriverId: subDriverId || null,
    };

    const request = id
      ? PUT(
        `/pn-bill-for-driver/update-pn-bill-for-rental-contract/${id}`,
        formData,
        {},
        true
      )
      : POST(
        `/pn-bill-for-driver/create-pn-bill-for-rental-contract/${data.id}`,
        formData,
        {},
        true
      );

    request
      .then((res) => {
        if (id) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        history.goBack();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onReCalculate = () => {
    const driveRentalContract = driveRentalContractOptions.find((c) => c.value === driveRentalContractId)?.data;
    if (driveRentalContract) {
      const deliveryFeeByDistanceData = driveRentalContract.deliveryFeeByDistanceData.find(
        (c) => c.truckIds.includes(truckId)
      );

      setValue("deliveryFeeByWeight", deliveryFeeByDistanceData.deliveryFeeByDistance);
      setValue("driverBonus", deliveryFeeByDistanceData.driverBonus);
      setValue("subDriverBonus", subDriverId ? deliveryFeeByDistanceData.subDriverBonus : 0);
    }
  }


  return (
    <React.Fragment>
      <Head title="Đơn hàng"></Head>

      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đơn hàng</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <Button
                          color="primary"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <span>Trở về</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <FormProvider {...methodForm}>
                    <form onSubmit={handleSubmit(onHandleSubmit)}>
                      <div className="mb-4">
                        <Row className="g-2">
                          <Col size="12" md="4">
                            <div className="form-group">
                              <label className="form-label" htmlFor="customer">
                                Mã đơn <span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <InputGroup>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="id"
                                    ref={register({
                                      required: "Vui lòng nhập thông tin",
                                    })}
                                    disabled={true}
                                  />
                                  <InputGroupAddon addonType="append">
                                    <Button disabled={!!id} type="button" color="primary" onClick={(e) => {
                                      e?.preventDefault();
                                      setValue("id", randomId());
                                    }}>
                                      <span>Tạo ngẫu nhiên</span>
                                    </Button>
                                  </InputGroupAddon>
                                </InputGroup>


                                <ErrorMessage
                                  errors={errors}
                                  name="id"
                                  render={({ message }) => (
                                    <span className="invalid">{message}</span>
                                  )}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col size="12" md="3">
                            <div className="form-group">
                              <label className="form-label" >
                                Thời gian tạo đơn<span className="text-danger">*</span>
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  rows={3}
                                  className="form-control"
                                  type="datetime-local"
                                  name="createdAt"
                                  ref={register({ required: "Vui lòng nhập thông tin" })}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="createdAt"
                                  render={({ message }) => (
                                    <span className="invalid">{message}</span>
                                  )}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <Row className="mt-3">
                        <Col size={12}>
                          <BlockTitle tag="h5" className={`text-primary`}>
                            Thông tin đơn hàng
                          </BlockTitle>
                        </Col>
                        <Col size="12" md="3">
                          <div className="form-group">
                            <label className="form-label" >
                              Hợp đồng thuê xe{` `}<span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="driveRentalContractId"
                                rules={{
                                  required: "Vui lòng nhập thông tin"
                                }}
                                render={({ onChange, name, value, ref }) => (
                                  <RSelect
                                    isClearable
                                    ref={ref}
                                    name={name}
                                    options={driveRentalContractOptions}
                                    value={
                                      driveRentalContractOptions.find((c) => +c.value === +value) || null
                                    }
                                    onChange={(val) => {
                                      onChange(val?.value);
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="driveRentalContractId"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col size="12" md="3">
                          <div className="form-group">
                            <label className="form-label" >
                              Xe tải{` `}<span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="truckId"
                                rules={{
                                  required: "Vui lòng nhập thông tin"
                                }}
                                render={({ onChange, name, value, ref }) => (
                                  <RSelect
                                    isClearable
                                    ref={ref}
                                    name={name}
                                    options={truckOptions}
                                    value={
                                      truckOptions.find((c) => c.value === value) || null
                                    }
                                    onChange={(val) => {
                                      onChange(val.value);
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="truckId"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>

                        <Col size="12" md="3">
                          <div className="form-group">
                            <label className="form-label" >
                              Nguyên liệu{!!ingredientOptions ? <>{` `}<span className="text-danger">*</span></> : ''}
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="ingredientId"
                                rules={{
                                  required: "Vui lòng nhập thông tin"
                                }}
                                render={({ onChange, name, value, ref }) => (
                                  <RSelect
                                    isClearable
                                    ref={ref}
                                    name={name}
                                    options={ingredientOptions}
                                    value={
                                      ingredientOptions.find((c) => c.value === value) || null
                                    }
                                    onChange={(val) => {
                                      onChange(val.value);
                                    }}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="ingredientId"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col size="12" md="3">
                          <div className="form-group">
                            <label className="form-label" >
                              Khối lượng(kg){` `}<span className="text-danger">*</span>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="finalMerchandiseWeight"
                                rules={{
                                  required: "Vui lòng nhập thông tin"
                                }}
                                render={({ onChange, value, ref }) => (
                                  <NumericFormat
                                    className="form-control"
                                    getInputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={0}
                                    onValueChange={(val) => onChange(val.floatValue)}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="finalMerchandiseWeight"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>


                        <Col size="12">
                          <div className="form-group">
                            <label className="form-label" >
                              Ghi chú
                            </label>
                            <div className="form-control-wrap">
                              <textarea
                                rows={3}
                                className="form-control"
                                style={{ height: "unset" }}
                                name="note"
                                ref={register()}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col size={12}>
                          <BlockTitle tag="h5" className={`text-primary`}>
                            Thông tin Tiền thưởng tài xế
                          </BlockTitle>
                        </Col>
                        <Col size="12" md="3">
                          <div className="form-group">
                            <label className="form-label" >
                              Tài xế
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="driverId"
                                render={({ onChange, value, name, ref }) => (
                                  <RSelect
                                    isDisabled={true}
                                    isClearable
                                    ref={ref}
                                    name={name}
                                    options={driverOptions}
                                    value={driverOptions.find((c) => c.value === value) || null}
                                    onChange={(val) => {
                                      onChange(val?.value || "");
                                      setValue("driverBonus", 0);
                                    }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </Col>

                        <Col size="12" md="3">
                          <div className="form-group">
                            <label className="form-label" >
                              Tiền tài chính(đ)<>{` `}<span className="text-danger">*</span></>
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="driverBonus"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, ref }) => (
                                  <NumericFormat
                                    disabled={true}
                                    className="form-control"
                                    getInputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={2}
                                    onValueChange={(val) => onChange(val.floatValue)}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="driverBonus"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>

                        <Col size="12" md="3">
                          <div className="form-group">
                            <label className="form-label" >
                              Tài phụ
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="subDriverId"
                                render={({ onChange, value, name, ref }) => (
                                  <RSelect
                                    isClearable
                                    ref={ref}
                                    name={name}
                                    options={driverOptions}
                                    value={driverOptions.find((c) => c.value === value) || null}
                                    onChange={(val) => {
                                      onChange(val?.value || '');
                                      setValue("subDriverBonus", 0);
                                    }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </Col>

                        <Col size="12" md="3">
                          <div className="form-group">
                            <label className="form-label" >
                              Tiền tài phụ(đ){!!subDriverId ? <>{` `}<span className="text-danger">*</span></> : ''}
                            </label>
                            <div className="form-control-wrap">
                              <Controller
                                control={control}
                                name="subDriverBonus"
                                rules={!!subDriverId ? { required: "Vui lòng nhập thông tin" } : {}}
                                render={({ onChange, value, ref }) => (
                                  <NumericFormat
                                    disabled={true}
                                    className="form-control"
                                    getInputRef={ref}
                                    type="text"
                                    value={value}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator=","
                                    decimalScale={2}
                                    onValueChange={(val) => onChange(val.floatValue)}
                                  />
                                )}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="subDriverBonus"
                                render={({ message }) => (
                                  <span className="invalid">{message}</span>
                                )}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row className="g-3 ">
                        <Col size="12" md="3" className="mt-3">
                          <Button color="secondary" type="button" onClick={onReCalculate} disabled={!driveRentalContractId || !truckId}>
                            <span>Tính lại tiền tài</span>
                          </Button>
                          <Button color="primary" type="submit" className={`ml-2`}>
                            <span>Lưu đơn hàng</span>
                          </Button>

                        </Col>

                      </Row>
                    </form>
                  </FormProvider>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default MyBillForRentalContractDetail;
